<template>
    <div>
        <template v-if="loading">
            <i class="fa fa-circle-o-notch fa-spin"></i> Loading
        </template>
        <template v-else>
            <div class="row">
                <input class="form-control col-xl-2 col-lg-3 col-md-4 col-sm-6 col-12 mb-3 mr-2" type="text" placeholder="Search Subcontractors" v-model="searchText">
                <div class="mb-3 ml-xl-2 px-0 col-xl-9 col-12">
                    <span class="d-lg-inline-block d-block mb-lg-0 mb-3">
                        <ul class="pagination mb-0 pb-0">
                            <li :class="{'page-item': true, 'disabled': current_page-10 < 1}">
                                <a style="background-color: #fff;" class="page-link" href="javascript:void(0)" @click="current_page -= 10">
                                    <<
                                </a>
                            </li>
                            <li :class="{'page-item': true, 'disabled': current_page-1 < 1}">
                                <a style="background-color: #fff;" class="page-link" href="javascript:void(0)" @click="current_page -= 1">
                                    <
                                </a>
                            </li>
                            <li v-for="page in visible_pages" :class="{'page-item': true, 'active': current_page == page}">
                                <a style="background-color: #fff;" class="page-link" href="javascript:void(0)" @click="current_page = page">
                                    {{ page }}
                                </a>
                            </li>
                            <li :class="{'page-item': true, 'disabled': current_page+1 > total_pages}">
                                <a style="background-color: #fff;" class="page-link" href="javascript:void(0)" @click="current_page += 1">
                                    >
                                </a>
                            </li>
                            <li :class="{'page-item': true, 'disabled': current_page+10 > total_pages}">
                                <a style="background-color: #fff;" class="page-link" href="javascript:void(0)" @click="current_page += 10">
                                    >>
                                </a>
                            </li>
                        </ul>
                    </span>
                    <span>{{ page_text }}</span>
                </div>
                <template v-if="visible_subs.length > 0">
                    <div v-for="sub in visible_subs" no-body class="card mb-3 col-12">
                        <div class="card-header pl-0">
                            <b-button :class="is_expanded[sub.subcontractor_id] ? null : 'collapsed'"
                                        :aria-expanded="is_expanded[sub.subcontractor_id] ? 'true' : 'false'"
                                        :aria-controls="`sub-${sub.subcontractor_id}`"
                                        @click="is_expanded[sub.subcontractor_id] = !is_expanded[sub.subcontractor_id]"
                                        variant="light"
                                        size="sm">
                                View
                            </b-button>
                            <strong>{{ sub.subcontractor_name }}</strong>
                        </div>
                        <b-collapse :id="`sub-${sub.subcontractor_id}`" v-model="is_expanded[sub.subcontractor_id]">
                            <b-card-body>
                                <client-subcontractor-approvals v-if="is_expanded[sub.subcontractor_id]" assetType="SubPreQual" :assetId="sub.subcontractor_id" :columns="columns"></client-subcontractor-approvals>
                            </b-card-body>
                        </b-collapse>
                    </div>
                </template>
                <template v-else>
                    <div no-body class="card mb-3 col-12">
                        <div class="card-header pl-0">
                            No Records Found
                        </div>
                    </div>
                </template>
            </div>
        </template>
    </div>
</template>

<script>
    export default {
        data: function() {
            return {
                columns: ['sub_approval_id', 'client_name', 'approval_status_name', 'approval_created_at'],
                subs: [],
                is_expanded: {},
                loading: true,
                searchText: '',

                current_page: 1,
                page_count: 25,
            }
        },

        computed: {
            visible_subs() {
                return this.filtered_subs.slice((this.current_page-1)*this.page_count,this.current_page*this.page_count);
            },

            filtered_subs() {
                this.current_page = 1;
                return this.subs.filter((sub) => {
                    return (sub.subcontractor_name.toLowerCase().indexOf(this.searchText.toLowerCase()) !== -1)
                });
            },

            visible_pages() {
                let start_page = Math.floor((this.current_page-1) / 10) * 10 + 1;
                let pages = [];
                let end_page = start_page + (window.outerWidth < 576 ? 4 : 9);
                for (let i = start_page; i <= end_page && i <= this.total_pages; i++) {
                    pages.push(i);
                }
                return pages;
            },

            total_pages() {
                return Math.ceil(this.filtered_subs.length / this.page_count);
            },

            page_text() {
                let total = this.filtered_subs.length;
                if (total === 0)
                {
                    return 'No records';
                }
                let first = (this.current_page-1)*this.page_count+1;
                let last = this.current_page == this.total_pages ? total : this.current_page*this.page_count;
                return `${first} to ${last} of ${total} records`;
            },
        },

        methods: {
            getSubs(){
                //Loading?
                this.loading = true;

                //Get the comments
                this.$http.get('/client-subcontractor-approval-list')
                    .then(response => {
                        //Set the comments
                        this.subs = response.data;
                        this.subs.forEach((sub) => {
                            this.$set(this.is_expanded, sub.subcontractor_id, false);
                        });
                    })
                    .catch(err => {

                    })
                    .then(response => {
                        //Reset loading
                        this.loading = false;
                    });
            },
        },

        mounted() {
            this.getSubs();
        }
    }
</script>